import { Order } from '@spartacus/order/root';
import { Observable } from 'rxjs';

export abstract class CheckOrderAdapter {
  abstract getOrder(orderId: string): Observable<Order>;
  abstract checkOrder(orderId: string): Observable<boolean>;
}
